import { createFileRoute } from '@tanstack/react-router';
import { AdminClaimsPage } from '../../features/tenancy';

export const Route = createFileRoute('/admin/claims')({ component: AdminClaimsPage });
